class ApiError extends Error {
  httpStatusCode: any;
  httpStatusText: any;
  responseCode: any;
  constructor(
    httpStatusCode: any,
    httpStatusText: any,
    responseCode: any,
    message: any
  ) {
    super(message);
    this.httpStatusCode = httpStatusCode;
    this.httpStatusText = httpStatusText;
    this.responseCode = responseCode;
  }
}

export const parseApiResponse = async (response: Response) => {
  if (response !== undefined) {
    // console.log('response here', response.json())
    const text = await response.text();
    let resp = text ? JSON.parse(text) : {};
    if (!resp.status) {
      return resp.message;
    } else {
      return resp;
    }
  } else {
    throw new Error("Response is Required");
  }
};

export const parseApiResponseJSON = async (response: {
  text: () => Promise<any>;
}) => {
  if (response !== undefined) {
    // console.log('response here', response.json())
    const text = await response.text();
    return text ? JSON.parse(text) : {};
  } else {
    throw new Error("Response is Required");
  }
};
